// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"364":"007ba08c","888":"15667cce"}[chunkId] + ".chunk.css";
};